import { initializeApp } from "firebase/app";
import {
  getRemoteConfig,
  fetchAndActivate,
  getValue,
} from "firebase/remote-config";
import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
import pjson from "../package.json";

let remoteConfig;

export async function setupFirebaseRemoteConfig() {
  const firebaseConfig = {
    apiKey: "AIzaSyCoFDOkhjykR9Vg1LkveyuvG3YF-yG8VJ8",
    authDomain: "mycon-bot.firebaseapp.com",
    projectId: "mycon-bot",
    storageBucket: "mycon-bot.firebasestorage.app",
    messagingSenderId: "202875895217",
    appId: "1:202875895217:web:7ca26bca480d3471931190",
    measurementId: "G-XV49G5D6Z6",
  };

  const firebaseApp = initializeApp(firebaseConfig);
  remoteConfig = getRemoteConfig(firebaseApp, {
    minimumFetchIntervalMillis: 60 * 1000,
    fetchTimeoutMillis: 60 * 1000,
  });
  remoteConfig.defaultConfig = {
    welcome_message: "Welcome",
    datadog_sample_rate: 5,
  };

  await fetchAndActivate(remoteConfig);
}

export function getRemoteConfigValue(key) {
  return getValue(remoteConfig, key);
}

export function setupDatadog() {
  console.log("Versão: " + pjson.version);
  let sampleRate = parseInt(
    getRemoteConfigValue("datadog_sample_rate").asNumber()
  );
  datadogRum.init({
    applicationId: "22d1a2c7-5fa2-485e-88b1-cabe136fc845",
    clientToken: "pub1f9fd56540ea6cd6d4ee38eb7c734911",
    site: "datadoghq.com",
    service: "bot2.0",
    env: process.env.NODE_ENV === "production" ? "production" : "development",
    version: pjson.version,
    sessionSampleRate: sampleRate,
    sessionReplaySampleRate: sampleRate,
    traceSampleRate: sampleRate,
    defaultPrivacyLevel: "allow",
    plugins: [reactPlugin({ router: true })],
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    allowedTracingUrls: [
      (url) =>
        url.includes("mycon.com.br") || url.includes("mycon-bot.pages.dev"),
    ],
  });
}
